/*
 * @Author: your name
 * @Date: 2020-09-11 17:09:53
 * @LastEditTime: 2020-12-01 16:02:11
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/cookie.js
 */
//设置cookie
export function setCookie(name, value, day) {
  //当前时间
  var oDate = new Date();

  if (day) {
    //设置到第几天的时间
    oDate.setDate(oDate.getDate() + day);
    document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
  } else {
    document.cookie = name + '=' + value + ';path=/';
  }
} //获取cookie

export function getCookie(name) {
  var cookies = document.cookie;
  var arr = cookies.split('; ');

  for (var i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split('='); // console.log(arr2);

    if (arr2[0] == name) {
      return arr2[1];
    }
  }

  return undefined; //返回同一种数据类型
} //删除cookie

export function removeCookie(name) {
  //根据过期时间来删除，value值不重要
  setCookie(name, 1, -1);
}
export function removeAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);

  if (keys) {
    for (var i = keys.length; i--;) document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
  }
}